/** Shared product accent (notes, list field focus, links) */
export const UI_ACCENT_BLUE = "#1976d2";

/** Option / day hover (8% opacity on accent) */
export const UI_ACCENT_BLUE_HOVER = "rgba(25, 118, 210, 0.08)";

/** List keyboard focus / selected row tint (12% opacity) */
export const UI_ACCENT_BLUE_OPTION_FOCUS = "rgba(25, 118, 210, 0.12)";

/** Qventus recommendation strips (Q-badge); light purple, distinct from action blue */
export const UI_ACCENT_SUGGESTION_BG = "#ede7f6"; // deepPurple[50]
export const UI_ACCENT_SUGGESTION_BORDER = "#d1c4e9"; // deepPurple[100]
